import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link as RouterLink } from 'react-router-dom'
import {
  Link,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@material-ui/core'

import { usePlace } from 'commons/usePlace'
import CancelButton from 'app/components/buttons/CancelButton'
import { Routes } from 'app/services/routeService/routeService'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import ResponsiveDialogAction from 'app/components/dialog/ResponsiveDialogAction'
import ReConfirmDeleteAdminDialog from 'app/components/ConfirmDeleteAdminDialog/ReConfirmDeleteAdminDialog'

function ConfirmDeleteAdminDialog({
  isOpen = false,
  onClose,
  onDelete,
  isLoading,
  isRootAdmin = true,
  clearDialog,
}) {
  const place = usePlace()

  const [isOpenReConfirm, setIsOpenReConfirm] = useState(false)

  return (
    <>
      <ResponsiveDialog
        open={isOpen}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        fullWidth
        maxWidth="sm"
        classes={{ paper: 'overflow-y-visible' }}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="flex justify-between items-center">
            <Typography variant="h6" className="uppercase">
              {isRootAdmin ? (
                <FormattedMessage id="delete.account.rootAdmin.title" />
              ) : (
                <FormattedMessage id="delete.account.teamMember.title" />
              )}
            </Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          {isRootAdmin ? (
            <DialogContentText className="text-black space-y-3">
              <Typography>
                <FormattedMessage id="delete.account.rootAdmin.header" />
              </Typography>
              <ul className="pl-10 space-y-3">
                <li>
                  <FormattedMessage
                    id="delete.account.rootAdmin.line1"
                    values={{
                      placeName: place.name,
                      b: (text) => <b>{text}</b>,
                    }}
                  />
                </li>
                <li>
                  <FormattedMessage
                    id="delete.account.rootAdmin.line2"
                    values={{
                      l1: (text) => (
                        <>
                          <Link
                            to={Routes.teamMembers()}
                            component={RouterLink}
                            className="font-bold no-underline"
                            onClick={() => clearDialog()}
                          >
                            {text}
                          </Link>
                        </>
                      ),
                    }}
                  />
                </li>
                <li>
                  <FormattedMessage id="delete.account.rootAdmin.line3" />
                </li>
              </ul>
            </DialogContentText>
          ) : (
            <DialogContentText className="text-black space-y-3">
              <Typography>
                <FormattedMessage id="delete.account.teamMember.header" />
              </Typography>
              <ul className="pl-10 space-y-3">
                <li>
                  <FormattedMessage id="delete.account.teamMember.line1" />
                </li>
                <li>
                  <FormattedMessage id="delete.account.teamMember.line2" />
                </li>
                <li>
                  <FormattedMessage id="delete.account.teamMember.line3" />
                </li>
              </ul>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <ResponsiveDialogAction
            StartButton={
              <CancelButton
                disabled={isLoading}
                onClick={() => {
                  onClose()
                }}
                className="w-full"
              />
            }
            EndButton={
              <PrimaryButton
                onClick={() => setIsOpenReConfirm(true)}
                disabled={isLoading}
              >
                <FormattedMessage id="delete.account.confirm.button.lable" />
              </PrimaryButton>
            }
          />
        </DialogActions>
      </ResponsiveDialog>
      {isOpenReConfirm ? (
        <ReConfirmDeleteAdminDialog
          isOpen={isOpenReConfirm}
          isLoading={isLoading}
          onClose={() => {
            setIsOpenReConfirm(false)
          }}
          onDelete={() => onDelete()}
        />
      ) : null}
    </>
  )
}

ConfirmDeleteAdminDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isRootAdmin: PropTypes.bool.isRequired,
  clearDialog: PropTypes.func.isRequired,
}

export default ConfirmDeleteAdminDialog
